import { gql } from '@apollo/client/core'
import { ADDRESS_FRAGMENT, PAGINATION_FRAGMENT } from '../Fragments'
import { Address } from 'types/address'

export interface AllAddressesDataType {
  allAddresses: Address
}

export const ALL_ADDRESSES = gql`
  query allAddresses {
    allAddresses {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
`
